import React from 'react';
import { useI18n } from '../i18n/i18nContext';
import LocalizedButton from './Button/LocalizedButton';

const Hero: React.FC = () => {
  const { t, language } = useI18n();
  const isLongLanguage = language === 'fi' || language === 'ru';
  const isEstonian = language === 'et';

  return (
    <div className="relative overflow-hidden py-16">
      {/* Background Image */}
      <img
        src="/images/hero-bg.webp"
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      {/* Content */}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 pt-16 text-center text-white md:pt-0">
        <div className="mx-auto max-w-4xl">
          <h1
            className={`${isEstonian ? 'text-3xl md:text-5xl' : 'text-3xl md:text-6xl'} animate-fadeIn animation-delay-0 mb-8 break-words px-2 font-bold leading-tight`}
          >
            {t.hero?.title || 'Welcome to Fire & Ice'}
          </h1>
          {/* <p className="animate-fadeIn animation-delay-1 mb-8 max-w-2xl text-lg md:text-2xl">
            {t.hero?.subtitle ||
              'Experience the ultimate wellness journey with our premium services'}
          </p> */}
          <div
            className={`mt-6 ${isLongLanguage ? 'text-base' : 'text-xl'} flex flex-col items-center font-semibold md:text-2xl`}
          >
            <div className="w-full text-center sm:hidden">
              <div className="grid grid-cols-2 gap-x-4 gap-y-2">
                <p className="animate-fadeIn animation-delay-2 break-words leading-tight">
                  {t.hero?.benefit1 || 'Perform Better'}
                </p>
                <p className="animate-fadeIn animation-delay-3 break-words leading-tight">
                  {t.hero?.benefit2 || 'Feel Better'}
                </p>
                <p className="animate-fadeIn animation-delay-4 break-words leading-tight">
                  {t.hero?.benefit3 || 'Work Better'}
                </p>
                <p className="animate-fadeIn animation-delay-5 break-words leading-tight">
                  {t.hero?.benefit4 || 'Sleep Better'}
                </p>
              </div>
            </div>

            <div className="hidden w-full text-center sm:block">
              <div className="inline-grid grid-cols-[auto_auto_auto_auto_auto] items-center justify-items-center gap-x-3 md:gap-x-4">
                <p className="animate-fadeIn animation-delay-2 whitespace-nowrap leading-tight">
                  {t.hero?.benefit1 || 'Perform Better'}
                </p>
                <span className="animate-fadeIn animation-delay-2 text-white/85">&bull;</span>
                <p className="animate-fadeIn animation-delay-3 whitespace-nowrap leading-tight">
                  {t.hero?.benefit2 || 'Feel Better'}
                </p>
                <span className="animate-fadeIn animation-delay-3 text-white/85">&bull;</span>
                <p className="animate-fadeIn animation-delay-4 whitespace-nowrap leading-tight">
                  {t.hero?.benefit3 || 'Work Better'}
                </p>

                <p className="animate-fadeIn animation-delay-5 col-start-3 mt-2 whitespace-nowrap leading-tight">
                  {t.hero?.benefit4 || 'Sleep Better'}
                </p>
              </div>
            </div>
            {/* <p className="animate-fadeIn animation-delay-6 mt-4 whitespace-nowrap font-bold">
              {t.hero?.benefit5 || 'Live Better'}
            </p> */}
          </div>
        </div>
        <section className="pt-10 text-center">
          <LocalizedButton
            to="/book"
            name={t.servicePage?.bookNow}
            size="md"
            variant="outline"
            className="uppercase"
          />
        </section>
      </div>
    </div>
  );
};

export default Hero;
